import { h, Host } from "@stencil/core";
import { getAceBettingPromoCardNames } from "./ace-betting-promo-card.get-names";
import { isMobile, hasSlot } from "@ace/web-components/dist_lib/utils";
export class AceBettingPromoCard {
    constructor() {
        this.hasActions = false;
        this.target = '_self';
        this.fullWidth = false;
        this.condensed = false;
        this.theme = 'default';
    }
    componentWillLoad() {
        var _a;
        this.names = getAceBettingPromoCardNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        this.hasActions = hasSlot(this.hostElement, 'actions');
    }
    renderImageSlot() {
        return (h("div", { class: this.names.CLASS.IMAGE_CONTAINER }, h("div", { class: this.names.CLASS.IMAGE }, h("slot", { name: 'image' }))));
    }
    renderActionsSlot() {
        return (h("div", { class: this.names.CLASS.ACTIONS }, h("slot", { name: 'actions' })));
    }
    renderText() {
        return [h("h4", { class: this.names.CLASS.HEADLINE }, this.headline), h("p", { class: this.names.CLASS.BODY }, this.body)];
    }
    getCardConfig(layout) {
        const isLink = this.href && (isMobile() || (!this.condensed && (!this.fullWidth || !this.hasActions)));
        const Tag = isLink ? 'a' : 'div';
        // Card element classes and attributes
        const tagAttributes = Object.assign({ id: this.names.ID.ROOT, class: {
                [this.names.ID.ROOT]: true,
                [this.names.CLASS.____FULL_WIDTH]: layout === 'default' && this.fullWidth,
                [this.names.CLASS.____SPORTS_THEME]: this.theme === 'sports',
                [this.names.CLASS.____CONDENSED]: layout === 'condensed',
            } }, (isLink ? { href: this.href, target: this.target } : {}));
        // Condensed or full width cards should not have a max-width
        const hostAttributes = this.condensed || this.fullWidth ? { style: { 'max-width': 'unset' } } : {};
        return { Tag, tagAttributes, hostAttributes };
    }
    renderCondensedLayout(Tag, tagAttributes) {
        return (h(Tag, Object.assign({}, tagAttributes), h("div", { class: this.names.CLASS.CONDENSED_CONTENT }, this.renderImageSlot(), h("div", { class: this.names.CLASS.CONDENSED_TEXT }, this.renderText())), this.renderActionsSlot(), h("div", { class: this.names.CLASS.BORDER })));
    }
    renderStandardLayout(Tag, tagAttributes) {
        return (h(Tag, Object.assign({}, tagAttributes), this.renderImageSlot(), h("div", { class: this.names.CLASS.CONTENT }, this.renderText(), this.renderActionsSlot()), h("div", { class: this.names.CLASS.BORDER })));
    }
    render() {
        const { Tag, tagAttributes, hostAttributes } = this.getCardConfig(this.condensed ? 'condensed' : 'default');
        return h(Host, Object.assign({ key: '675b97b2c8e0314e729a84a8213c6d6ec958aa62' }, hostAttributes), this.condensed ? this.renderCondensedLayout(Tag, tagAttributes) : this.renderStandardLayout(Tag, tagAttributes));
    }
    static get is() { return "ace-betting-promo-card"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-betting-promo-card.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-betting-promo-card.css"]
        };
    }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "href",
                "reflect": false
            },
            "target": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "target",
                "reflect": false,
                "defaultValue": "'_self'"
            },
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "headline",
                "reflect": false
            },
            "body": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "body",
                "reflect": false
            },
            "imageSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "image-src",
                "reflect": false
            },
            "fullWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "full-width",
                "reflect": false,
                "defaultValue": "false"
            },
            "condensed": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "condensed",
                "reflect": false,
                "defaultValue": "false"
            },
            "theme": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingPromoCardTheme",
                    "resolved": "\"default\" | \"sports\"",
                    "references": {
                        "IAceBettingPromoCardTheme": {
                            "location": "import",
                            "path": "./ace-betting-promo-card.types",
                            "id": "src/components/ace-betting-promo-card/ace-betting-promo-card.types.ts::IAceBettingPromoCardTheme"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "theme",
                "reflect": false,
                "defaultValue": "'default'"
            }
        };
    }
    static get elementRef() { return "hostElement"; }
}
//# sourceMappingURL=ace-betting-promo-card.js.map
